<template>
  <div class="triangle full-width">
    <div class="triangle__wrapper">
      <div class="triangle__first"><svg viewBox="0 0 25 49" preserveAspectRatio="none" width="25" height="49" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h25v49z"/></svg></div>
      <div class="triangle__last"><svg viewBox="0 0 295 49" preserveAspectRatio="none" width="295" height="49" xmlns="http://www.w3.org/2000/svg"><path d="M0 0v49L295 0z"/></svg></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Triangle',
};
</script>
